<template>
  <div class="artist-lists">
    <v-artist-list
      v-for="(data, i) in sortedData"
      :id="`list-${i}`"
      :key="i"
      :level-id="data.levelId"
      :level="data.level"
      :data="data.data"
      :artist-id="artistId"
      :can-navigate="canNavigate"
      @mouseoverartist="$emit('mouseoverartist', $event)"
      @mouseoverrole="$emit('mouseoverrole', $event)"
    />
  </div>
</template>

<script>

import ArtistList from "./ArtistList";

export default {
	components: {
		"v-artist-list": ArtistList
	},
	props: {
		canNavigate: {
			type: Boolean,
			default: true
		},
		artistId: {
			type: String,
			required: true
		},
		artists: {
			type: Array,
			required: true
		}
	},
	computed: {
		artist () {
			return this.$store.state.artists[this.artistId];
		},
		levels () {
			return [
				{label: "Top inspirators", tooltip: `Artists who inspired the songs where ${this.artist.name} is involved`, color: this.color(0)},
				{label: "Top collaborators", tooltip: `Artists who collaborated in the production of songs where ${this.artist.name} is involved`, color: this.color(1)},
				{label: "Top influenced", tooltip: `Artists influenced by the songs where ${this.artist.name} is involved`, color: this.color(2)},
			];
		},
		sortedData () {
			let data = [];
			this.levels.forEach((level, i) => {
				data.push({
					levelId: i,
					level: level,
					data: this.artists
						.filter(a => a.scores[i].total > 0 && a.id != this.artistId)
						.sort((a,b) => {
							if (a.scores[i].total == b.scores[i].total) {
								return this.$store.state.artists[a.id].name < this.$store.state.artists[b.id].name ? -1 : 1;
							}
							return (a.scores[i].total > b.scores[i].total) ? -1 : 1;
						})
						.map(a => {
							a.artist = this.$store.state.artists[a.id];
							return a;
						})
				});
			});
			return data;
		}
	},
	mounted () {
		this.$emit("mounted");
	},
	methods: {
		color (timeline) {
			return this.$parent.timeline.colors[timeline];
		}
	}
};
</script>

<style lang="scss" scoped>
.artist-lists {
    display: flex;
    border-top: 1px #f1f1f1 solid;
    border-bottom: 1px #f1f1f1 solid;
    border-left: 1px #f1f1f1 solid;
}
</style>
